import Vue from 'vue';
import util from '@tencent/vft-common/util';
import tenvideo from '@tencent/vft-common/tenvideo';
import env from '@tencent/vft-common/env';
import { removeHttp } from "./removeHttp";
export function openUrl(url) {
  var sandbox = util.getUrlParam('sandbox') ? 1 : '';
  url = removeHttp(url);
  var ptag = util.getUrlParam('ptag') || util.getUrlParam('ptag', url) || '';
  url = util.delQueStr(url, 'ptag');
  url = util.setUrlParam('ptag', ptag, url);
  var ru = util.getUrlParam('ru', url);

  if (ru) {
    ru = decodeURIComponent(ru);
    ru = util.setUrlParam('ptag', ptag, ru);
    ru = encodeURIComponent(ru);
    url = util.setUrlParam('ru', ru, url);
  }

  url = util.setUrlParam('sandbox', sandbox, url);

  if (tenvideo.isAllTenvideo() && !env.isIpad) {
    tenvideo.openUrl(url);
  } else {
    window.location.href = url;
  }
}
export function mixinOpenUrl() {
  Vue.mixin({
    methods: {
      openUrl: openUrl
    }
  });
}